import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "/nav-logo.png";

export const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/roi', label: 'ROI' },
    { path: '/book-demo', label: 'Book Demo' },
    { path: '/grade-my-site', label: 'Grade My Site' },
    { path: '/admin', label: 'The Hub' },
  ];

  return (
    <>
      <nav data-testid="main-nav" style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: '#fff',
        borderBottom: '4px solid #000',
        padding: '0 1.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '90px',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
          <img src={LOGO_URL} alt="HungrMates" style={{ height: '85px', width: 'auto' }} />
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }} className="desktop-nav">
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              style={{
                color: isActive(link.path) ? '#6A0DAD' : '#000',
                textDecoration: 'none',
                fontSize: '0.9375rem',
                fontWeight: isActive(link.path) ? 800 : 700,
                padding: '6px 12px',
                borderRadius: '6px',
                transition: 'all 0.15s ease',
                textTransform: 'uppercase',
                letterSpacing: '0.02em',
                background: isActive(link.path) ? 'rgba(106, 13, 173, 0.08)' : 'transparent',
                border: isActive(link.path) ? '2px solid #6A0DAD' : '2px solid transparent',
              }}
              onMouseEnter={(e) => {
                if (!isActive(link.path)) {
                  e.target.style.background = '#FFF9DB';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive(link.path)) {
                  e.target.style.background = 'transparent';
                }
              }}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://www.admin.hungrmates.com/admin/login"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="admin-panel-btn"
            className="btn-purple"
            style={{ marginLeft: '0.5rem', padding: '10px 20px', fontSize: '0.875rem', display: 'none' }}
          >
            The Hub
          </a>
        </div>

        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            display: 'none',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '0.5rem',
            color: '#000',
          }}
          className="mobile-menu-btn"
        >
          {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {mobileMenuOpen && (
        <div style={{
          position: 'fixed',
          top: '74px',
          left: '0.75rem',
          right: '0.75rem',
          zIndex: 40,
          background: '#fff',
          borderRadius: '12px',
          padding: '1rem',
          border: '4px solid #000',
          boxShadow: '8px 8px 0px 0px #000',
        }}>
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMobileMenuOpen(false)}
              style={{
                display: 'block',
                padding: '0.75rem 1rem',
                color: isActive(link.path) ? '#6A0DAD' : '#000',
                textDecoration: 'none',
                fontWeight: 700,
                textTransform: 'uppercase',
                borderRadius: '8px',
                background: isActive(link.path) ? 'rgba(106, 13, 173, 0.08)' : 'transparent',
              }}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://www.admin.hungrmates.com/admin/login"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMobileMenuOpen(false)}
            className="btn-purple"
            style={{ marginTop: '0.75rem', width: '100%', display: 'none' }}
          >
            The Hub
          </a>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </>
  );
};
